<template>
  <!--
    进件成功推荐产品页（tl12）
    UI 对齐小程序 pages/product/product.wxml
    数据：POST /product/api/h5RecommendProduct
    返回挽留：对齐 public/func/productList.html（popstate + h5cpa/quit）
  -->
  <div class="page">
    <!-- 顶部背景（共通图 public/img/common/top_bg.png） -->
    <img
      class="top-bg__image"
      src="../../public/img/common/top_bg.png"
      alt=""
    />
    <div class="page-content">
      <!-- 顶部成功卡片 -->
      <div class="passed-banner">
        <img
          class="passed-banner__bg"
          src="../../public/img/trialSuccess_tl12/product_card_bg.png"
          alt=""
        />
        <div class="passed-banner__body">
          <div class="passed-banner__main">
            <img
              class="passed-banner__icon"
              src="../../public/img/trialSuccess_tl12/white_check_icon.png"
              alt=""
            />
            <div class="passed-banner__text">
              <span class="passed-banner__title">恭喜您！</span>
              <span class="passed-banner__title">您已成功通过分享借的初审</span>
            </div>
          </div>
          <span class="passed-banner__sub"
            >经评估，您的资质已超过90%用户，已为您解锁更高额度！</span
          >
        </div>
      </div>

      <!-- 产品详情卡片 -->
      <div class="product-card">
        <div class="product-card__badge">
          <img
            class="product-card__badge-bg"
            src="../../public/img/trialSuccess_tl12/gold_msg_bg.png"
            alt=""
          />
          <span class="product-card__badge-text">优质客户专享</span>
        </div>

        <div class="product-card__header">
          <img v-if="imgUrl" class="product-card__logo" :src="imgUrl" alt="" />
          <div v-else class="product-card__logo product-card__logo--empty" />
          <div class="product-card__info">
            <span class="product-card__name">{{
              productName || "推荐产品"
            }}</span>
            <div v-if="tagList.length" class="product-card__tags">
              <span
                v-for="(tag, index) in tagList"
                :key="index"
                class="product-card__tag"
                >{{ tag }}</span
              >
            </div>
          </div>
        </div>

        <div class="product-card__stats">
          <div class="product-card__stat">
            <span
              class="product-card__stat-value product-card__stat-value--brand"
              >{{ maxAmount }}</span
            >
            <span class="product-card__stat-label">最高可借额度(元)</span>
          </div>
          <div class="product-card__stat">
            <span class="product-card__stat-value">{{ interestRate }}</span>
            <span class="product-card__stat-label">年利率低至</span>
          </div>
          <div class="product-card__stat">
            <span class="product-card__stat-value">{{ applicantCount }}</span>
            <span class="product-card__stat-label">申请人数</span>
          </div>
        </div>

        <div class="product-card__hot">
          <img
            class="product-card__hot-icon"
            src="../../public/img/trialSuccess_tl12/fire_icon.png"
            alt=""
          />
          <span class="product-card__hot-text"
            >申请人数：{{ hotApplicantCount }}人</span
          >
        </div>

        <div
          class="product-card__claim-btn"
          :class="{
            'product-card__claim-btn--disabled': claiming,
            'product-card__claim-btn--download': !isProductsFlow,
          }"
          @click="onClaim"
        >
          {{ claimBtnText }}
        </div>
        <div
          v-if="isProductsFlow"
          class="product-card__abandon"
          @click="onAbandon"
        >
          放弃额度
        </div>
        <!-- 协议：有 productContractDTOS 才展示 -->
        <div
          v-if="isProductsFlow && hasContracts"
          class="agreement-row"
          @click="onToggleAgreement"
        >
          <img
            v-if="agreed"
            class="agreement-checkbox"
            src="../../public/img/register/register_tl12/check_circle_icon.png"
            alt=""
          />
          <img
            v-else
            class="agreement-checkbox"
            src="../../public/img/register/register_tl12/circle_icon.png"
            alt=""
          />
          <span class="agreement-text"
            >我已阅读并同意签署<span
              v-for="(c, i) in contracts"
              :key="i"
              class="agreement-link"
              @click.stop="onShowProtocol(c)"
              >《{{ c.contractName }}》</span
            ></span
          >
        </div>
      </div>

      <!-- 申请流程 -->
      <div class="process-section">
        <div class="process-section__header">
          <img
            class="process-section__arrow"
            src="../../public/img/trialSuccess_tl12/arrow_left.png"
            alt=""
          />
          <span class="process-section__title">申请流程</span>
          <img
            class="process-section__arrow"
            src="../../public/img/trialSuccess_tl12/arrow_right.png"
            alt=""
          />
        </div>
        <div class="process-section__steps">
          <div class="process-section__step">
            <img
              class="process-section__step-icon process-section__step-icon--download"
              src="../../public/img/trialSuccess_tl12/download_icon.png"
              alt=""
            />
            <span class="process-section__step-label">下载APP</span>
          </div>
          <div class="process-section__step">
            <img
              class="process-section__step-icon process-section__step-icon--edit"
              src="../../public/img/trialSuccess_tl12/edit_icon.png"
              alt=""
            />
            <span class="process-section__step-label">填写信息</span>
          </div>
          <div class="process-section__step">
            <img
              class="process-section__step-icon process-section__step-icon--card"
              src="../../public/img/trialSuccess_tl12/card_icon.png"
              alt=""
            />
            <span class="process-section__step-label">绑定银行卡</span>
          </div>
          <div class="process-section__step">
            <img
              class="process-section__step-icon process-section__step-icon--rmb"
              src="../../public/img/trialSuccess_tl12/renminbi_icon.png"
              alt=""
            />
            <span class="process-section__step-label">放贷</span>
          </div>
          <div class="process-section__step">
            <img
              class="process-section__step-icon process-section__step-icon--change"
              src="../../public/img/trialSuccess_tl12/change_icon.png"
              alt=""
            />
            <span class="process-section__step-label">还款</span>
          </div>
        </div>
      </div>
    </div>

    <!-- quitProductId 有值后组件才注册返回拦截 -->
    <quit-retain-modal
      v-if="recommendProduct && recommendProduct.productId"
      :quit-product-id="recommendProduct.productId"
      :allow-leave="allowLeave"
      show-cancel
      @apply="onQuitApply"
      @cancel="onQuitCancel"
    />

    <!-- 协议弹窗（对齐 registerEntry_tl12） -->
    <div class="protocol-modal" v-if="showProtocolModal" @touchmove.prevent>
      <div class="protocol-modal__mask" @click="onCloseProtocolModal"></div>
      <div class="protocol-modal__sheet" @touchmove.stop>
        <div class="protocol-modal__header">
          <span class="protocol-modal__title">{{ protocolTitle }}</span>
          <span class="protocol-modal__close" @click="onCloseProtocolModal"
            >×</span
          >
        </div>
        <div class="protocol-modal__body">
          <div class="protocol-modal__content" v-html="protocolContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 进件成功推荐产品页（tl12）
 *
 * 对齐小程序 pages/product：
 * 1. 进入页拉单条 CPA 推荐：POST /product/api/h5RecommendProduct
 * 2. 「领取额度」：必要时撞库 /product/api/check → Cookie → convenientEntrance → 三方
 * 3. 无产品 / 领取失败：跳转 /func/productList.html
 * 4. 浏览器返回挽留：QuitRetainModal 组件（对齐 productList）
 *
 * 入参 query：source、reqId、brand、amount、isRedirectProductsPage
 * 渠道成功页可将 downPageUrl 配为 /trialSuccess_tl12
 *
 * isRedirectProductsPage：
 * - 1 贷超：拉推荐产品，「领取额度」→ 撞库 / 中转 / 三方
 * - 0 非贷超：进入页直接跳转 applyResult
 */
import * as API_Common from "@/api/common.js";
import Storage from "@/utils/storage";
import QuitRetainModal from "@/components/QuitRetainModal/index.vue";

export default {
  name: "TrialSuccessTl12",
  components: { QuitRetainModal },
  data() {
    const query = this.$route.query;
    return {
      channel: query.source || "", // 渠道标识
      reqId: query.reqId || "", // 流水号（跳转贷超时透传）
      brand: query.brand || "", // 设备品牌（下载页小米商店用）
      loanAmount: query.amount || query.loanAmount || 0, // 借款金额（跳转 applyResult）
      // 1=贷超流程，0=非贷超下载 APP
      isRedirectProductsPage: parseInt(query.isRedirectProductsPage, 10),
      productName: "", // 产品名称（展示）
      imgUrl: "", // 产品 logo
      tagList: [], // 产品标签
      maxAmount: "--", // 最高可借额度
      interestRate: "--", // 年利率展示文案，如 7.2%
      applicantCount: "--", // 申请人数
      hotApplicantCount: "--", // 热度文案用申请人数
      loading: true, // 推荐产品加载中
      claiming: false, // 领取额度防重复点击
      recommendProduct: null, // 当前页推荐产品（领取 / 挽留 quit 入参 productId）
      allowLeave: false, // true 时 QuitRetainModal 不再拦截返回
      agreed: false, // 协议勾选
      showProtocolModal: false,
      protocolTitle: "",
      protocolContent: "",
    };
  },
  computed: {
    /** 贷超流程：isRedirectProductsPage === 1（缺省按贷超，兼容旧链接） */
    isProductsFlow() {
      return this.isRedirectProductsPage !== 0;
    },
    /** 产品协议列表 */
    contracts() {
      const list = this.recommendProduct?.productContractDTOS;
      return Array.isArray(list) ? list : [];
    },
    hasContracts() {
      return this.contracts.length > 0;
    },
    claimBtnText() {
      if (this.claiming) {
        return "跳转中...";
      }
      return this.isProductsFlow ? "领取额度" : "下载APP，查看实时放款进度";
    },
  },
  mounted() {
    // 非贷超：不展示本页，直接进下载结果页
    if (!this.isProductsFlow) {
      this.goApplyResult();
      return;
    }
    this.loadRecommendProduct();
  },
  methods: {
    /**
     * 拉取 CPA 推荐产品
     * POST /product/api/h5RecommendProduct
     * 无 data：贷超 → productList；非贷超 → applyResult
     */
    async loadRecommendProduct() {
      this.loading = true;
      this.recommendProduct = null;

      try {
        const res = await API_Common.h5RecommendProduct({
          channel: this.channel,
          hasWeChat: 0,
          pageNum: 1,
          pageSize: 10,
        });

        if (res?.code === 200) {
          if (!res.data) {
            this.redirectOnNoProduct();
            return;
          }

          const product = res.data;
          this.recommendProduct = product;

          const rate = product.timeLimitLoanRate;
          const interestRate = rate != null && rate !== "" ? `${rate}%` : "--";

          // 标签优先 tagList，否则用 hotTipTxt 兜底
          const tagList =
            Array.isArray(product.tagList) && product.tagList.length
              ? product.tagList
              : product.hotTipTxt
              ? [product.hotTipTxt]
              : [];

          this.productName = product.productName || "";
          this.imgUrl = product.imgUrl || "";
          this.tagList = tagList;
          this.maxAmount = String(
            product.maxAmount || product.creditAmount || "--"
          );
          this.interestRate = interestRate;
          this.applicantCount = String(product.loanNumber ?? "--");
          this.hotApplicantCount = String(product.loanNumber ?? "--");
          this.agreed = false;
          this.loading = false;
          return;
        }

        this.loading = false;
        this.$toast(res?.msg || "获取推荐产品失败");
      } catch (error) {
        console.error("[trialSuccess_tl12] loadRecommendProduct failed", error);
        this.loading = false;
        this.$toast("获取推荐产品失败");
      }
    },

    /** 无推荐产品：贷超去列表，非贷超去下载结果页 */
    redirectOnNoProduct() {
      if (this.isProductsFlow) {
        this.redirectToProductList();
        return;
      }
      this.goApplyResult();
    },

    /** 跳转贷超列表（与其它 trialSuccess 入口 query 约定一致） */
    redirectToProductList() {
      const timestamp = Date.now();
      window.location.href = `/func/productList.html?source=${this.channel}&tsp=${timestamp}&reqId=${this.reqId}`;
    },

    /**
     * 打开产品链接（领取额度 / 挽留立即申请共用）
     *
     * 流程对齐 productList.handleGoLink + convenientEntrance：
     * 1. checkMobileStatus !== 0 → POST /product/api/check 取 linkUrl
     * 2. 写入 Cookie 供中转页展示、埋点、跳转：
     *    imgUrl / productName / productId / linkUrl / sourceType(2=已登录)
     * 3. allowLeave=true 后跳转 ConvenientEntrance
     *
     * @param {Object} product 产品对象
     * @param {{ onFailRedirect?: boolean }} options
     *   onFailRedirect=false 时失败不跳贷超（挽留立即申请场景）
     */
    async openProductLink(product, options = {}) {
      const { onFailRedirect = true } = options;
      if (!product?.productId) {
        this.$toast("暂无推荐产品");
        if (onFailRedirect) {
          this.redirectToProductList();
        }
        return false;
      }

      this.claiming = true;

      try {
        let linkUrl = product.linkUrl || "";

        // checkMobileStatus !== 0：需撞库换取最终 linkUrl
        if (Number(product.checkMobileStatus) !== 0) {
          const res = await API_Common.checkProduct({
            productId: product.productId,
          });
          if (res?.code !== 200 || !res.data?.linkUrl) {
            this.$toast.fail(res?.msg || "获取地址失败");
            this.claiming = false;
            if (onFailRedirect) {
              this.redirectToProductList();
            }
            return false;
          }
          linkUrl = res.data.linkUrl;
        }

        if (!linkUrl) {
          this.$toast.fail("获取地址失败");
          this.claiming = false;
          if (onFailRedirect) {
            this.redirectToProductList();
          }
          return false;
        }

        // 中转页 convenientEntrance 读取的 Cookie
        Storage.setItem("imgUrl", product.imgUrl || "");
        Storage.setItem("productName", product.productName || "");
        Storage.setItem("productId", product.productId);
        Storage.setItem("linkUrl", linkUrl);
        Storage.setItem("sourceType", 2); // 已登录埋点

        this.allowLeave = true; // 跳转三方，后续返回不再弹挽留
        this.$router.push({
          name: "ConvenientEntrance",
          query: {
            source: this.channel,
            productId: product.productId,
          },
        });
        return true;
      } catch (error) {
        console.error("[trialSuccess_tl12] openProductLink failed", error);
        this.$toast.fail("获取地址失败");
        this.claiming = false;
        if (onFailRedirect) {
          this.redirectToProductList();
        }
        return false;
      }
    },

    /**
     * 主按钮：
     * - 贷超：领取额度 → 产品链接
     * - 非贷超：下载 APP → applyResult
     */
    async onClaim() {
      if (this.claiming) return;
      if (!this.isProductsFlow) {
        this.goApplyResult();
        return;
      }
      if (this.hasContracts && !this.agreed) {
        this.$toast("请先阅读并同意签署协议");
        return;
      }
      await this.openProductLink(this.recommendProduct);
    },

    onToggleAgreement() {
      this.agreed = !this.agreed;
    },

    onShowProtocol(contract) {
      if (!contract) return;
      this.protocolTitle = contract.contractName || "协议";
      this.protocolContent = contract.contractContent || "";
      this.showProtocolModal = true;
      this.lockPageScroll();
    },

    onCloseProtocolModal() {
      this.showProtocolModal = false;
      this.protocolTitle = "";
      this.protocolContent = "";
      this.unlockPageScroll();
    },

    lockPageScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      this._protocolScrollTop = scrollTop;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollTop}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";
    },

    unlockPageScroll() {
      if (document.body.style.position !== "fixed") return;
      const scrollTop = this._protocolScrollTop || 0;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      document.body.style.overflow = "";
      window.scrollTo(0, scrollTop);
      this._protocolScrollTop = 0;
    },

    /** 非贷超：跳转下载结果页 */
    goApplyResult() {
      this.allowLeave = true;
      this.$router.push({
        name: "ApplyResult",
        query: {
          source: this.channel,
          brand: this.brand,
          loanAmount: this.loanAmount,
        },
      });
    },

    /**
     * 挽留弹窗「立即申请」
     * 失败仅 toast，不跳贷超（onFailRedirect: false）
     */
    async onQuitApply(product) {
      if (this.claiming) return;
      await this.openProductLink(product, { onFailRedirect: false });
    },

    /** 挽留弹窗「取消」→ 跳转贷超列表 */
    onQuitCancel() {
      this.allowLeave = true;
      this.redirectToProductList();
    },

    /** 贷超：放弃额度 → 跳转贷超列表 */
    onAbandon() {
      this.allowLeave = true;
      this.redirectToProductList();
    },
  },
};
</script>

<style lang="scss" scoped>
/* 样式对齐小程序 pages/product（rpx → rem，约 100rpx = 1rem） */
.page {
  position: relative;
  min-height: 100vh;
  background-color: #f5f5f5;
  box-sizing: border-box;
}

.top-bg__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  pointer-events: none;
}

.page-content {
  position: relative;
  z-index: 1;
  padding: 0.5rem 0.3rem 0.48rem;
  box-sizing: border-box;
}

/* 顶部成功卡片 */
.passed-banner {
  position: relative;
  width: 100%;
  height: 2.2rem;
  margin: 0 auto 0.24rem;
  border-radius: 0.16rem;
  overflow: hidden;
}

.passed-banner__bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.passed-banner__body {
  position: relative;
  z-index: 1;
  height: 100%;
  padding: 0.32rem 0.3rem 0.28rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.passed-banner__main {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.passed-banner__icon {
  width: 0.68rem;
  height: 0.68rem;
  flex-shrink: 0;
}

.passed-banner__text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.04rem;
}

.passed-banner__title {
  font-size: 0.32rem;
  color: #fff;
  line-height: 1.4;
}

.passed-banner__sub {
  font-size: 0.24rem;
  color: #e5ebfc;
  line-height: 1.4;
}

/* 产品详情卡片 */
.product-card {
  position: relative;
  background: #fff;
  border-radius: 0.24rem;
  box-shadow: 0 0.04rem 0.16rem rgba(0, 0, 0, 0.04);
  padding: 0.4rem 0.32rem 0.36rem;
  margin-bottom: 0.32rem;
  overflow: hidden;
}

.product-card__badge {
  position: absolute;
  top: 0;
  right: 0;
  width: 1.76rem;
  height: 0.6rem;
}

.product-card__badge-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.product-card__badge-text {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  text-align: center;
  color: #fff;
  font-size: 0.24rem;
}

.product-card__header {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  margin-bottom: 0.4rem;
  padding-right: 1.2rem;
}

.product-card__logo {
  width: 1rem;
  height: 1rem;
  border-radius: 0.16rem;
  flex-shrink: 0;
  background: #f5f5f5;
  object-fit: cover;
}

.product-card__logo--empty {
  display: block;
}

.product-card__info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.08rem;
  min-width: 0;
}

.product-card__name {
  font-size: 0.32rem;
  font-weight: 500;
  color: #202020;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-card__tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.16rem;
}

.product-card__tag {
  font-size: 0.24rem;
  color: #999;
  line-height: 1.4;
}

.product-card__stats {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.32rem;
}

.product-card__stat {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.12rem;
}

.product-card__stat-value {
  font-size: 0.4rem;
  color: #2e2525;
  line-height: 1.2;
}

.product-card__stat-value--brand {
  color: #678cf9;
}

.product-card__stat-label {
  font-size: 0.24rem;
  color: #999;
  text-align: center;
  line-height: 1.3;
}

.product-card__hot {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.08rem;
  margin-bottom: 0.32rem;
}

.product-card__hot-icon {
  width: 0.32rem;
  height: 0.42rem;
  flex-shrink: 0;
}

.product-card__hot-text {
  font-size: 0.28rem;
  color: #999;
}

.product-card__claim-btn {
  height: 0.96rem;
  line-height: 0.96rem;
  border-radius: 0.48rem;
  background: #678cf9;
  color: #fff;
  font-size: 0.34rem;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
}

.product-card__claim-btn--disabled {
  opacity: 0.6;
  pointer-events: none;
}

.product-card__abandon {
  margin-top: 0.24rem;
  font-size: 0.28rem;
  color: #999;
  text-align: center;
  line-height: 1;
  cursor: pointer;
}

/* 协议勾选（对齐 registerEntry_tl12） */
.agreement-row {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.12rem;
  margin-top: 0.24rem;
  padding-left: 0.4rem;
  cursor: pointer;
}

.agreement-checkbox {
  width: 0.28rem;
  height: 0.28rem;
  flex-shrink: 0;
  margin-top: 0.04rem;
}

.agreement-text {
  flex: 0 1 auto;
  max-width: calc(100% - 0.4rem);
  font-size: 0.24rem;
  color: #999;
  line-height: 1.5;
  word-break: break-all;
}

.agreement-link {
  color: #678cf9;
}

/* 协议弹窗 */
.protocol-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}

.protocol-modal__mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.protocol-modal__sheet {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  height: 80vh;
  max-height: 80vh;
  background-color: #fff;
  border-radius: 0.24rem 0.24rem 0 0;
  box-sizing: border-box;
  overflow: hidden;
}

.protocol-modal__header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0.32rem;
  border-bottom: 0.01rem solid #f0f0f0;
}

.protocol-modal__title {
  color: #333;
  font-size: 0.32rem;
  font-weight: 500;
}

.protocol-modal__close {
  position: absolute;
  right: 0.24rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.4rem;
  line-height: 1;
  padding: 0.08rem;
  color: #999;
  cursor: pointer;
}

.protocol-modal__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.protocol-modal__content {
  padding: 0.24rem 0.32rem 0.48rem;
  color: #666;
  font-size: 0.28rem;
  line-height: 1.6;
  word-break: break-all;
}

/* 申请流程 */
.process-section {
  padding-bottom: 0.48rem;
}

.process-section__header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.16rem;
  margin: 0.6rem 0;
}

.process-section__arrow {
  width: 0.65rem;
  height: 0.22rem;
  flex-shrink: 0;
}

.process-section__title {
  font-size: 0.28rem;
  color: #999;
}

.process-section__steps {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.process-section__step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.12rem;
}

.process-section__step-icon--download {
  width: 0.47rem;
  height: 0.48rem;
}

.process-section__step-icon--edit {
  width: 0.46rem;
  height: 0.48rem;
}

.process-section__step-icon--card {
  width: 0.56rem;
  height: 0.48rem;
}

.process-section__step-icon--rmb,
.process-section__step-icon--change {
  width: 0.48rem;
  height: 0.48rem;
}

.process-section__step-label {
  font-size: 0.24rem;
  color: #999;
  text-align: center;
  white-space: nowrap;
}
</style>
